/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsvspreviousweek3Inputs */

const en_statsvspreviousweek3 = /** @type {(inputs: Statsvspreviousweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs. the 7 days before`)
};

const de_statsvspreviousweek3 = /** @type {(inputs: Statsvspreviousweek3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ggü. den 7 Tagen davor`)
};

/**
* | output |
* | --- |
* | "vs. the 7 days before" |
*
* @param {Statsvspreviousweek3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsvspreviousweek3 = /** @type {((inputs?: Statsvspreviousweek3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsvspreviousweek3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsvspreviousweek3(inputs)
	return de_statsvspreviousweek3(inputs)
});
export { statsvspreviousweek3 as "statsVsPreviousWeek" }